import { render, staticRenderFns } from "./AlvoradaMedicamentoEspeciais.vue?vue&type=template&id=832adbb8&scoped=true"
import script from "./AlvoradaMedicamentoEspeciais.vue?vue&type=script&lang=ts"
export * from "./AlvoradaMedicamentoEspeciais.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaMedicamentoEspeciais.vue?vue&type=style&index=0&id=832adbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832adbb8",
  null
  
)

export default component.exports